import jsPDF from 'jspdf';
import moment from 'moment';
import { groupBy } from 'lodash';

import dateFormat from 'config/dateFormat';

import formatPrice from 'utils/formatPrice';
import patientDobToAge from 'utils/patientDobToAge';
import formatSinglePlural from 'utils/formatSinglePlural';

import palette from 'styles/palette';

const apiDateFormat = 'YYYYMMDD';
const iconCheckCircle = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACX0lEQVRIidWVy2sTURTGvzNj27Q1dCGWIq6SNAQSQYwrN4KRbpNUspA20JVCd4mJBVezk3Ziu7KiK0nsxmfqTmoV/4C4sBFDHq4qQgQhrRJqmDkukkkmmTGTuOsHA3POuff33XvuPIDjLupX9EqR0YZ9PMxAEMQXAJxtlfbB9JFJzY4dHGU/S8/+DG0we2/xGojWADgsllgBcLsUy7wczOBpRHTt21YJuNUX3CumVOnQsQJJUvVpoXfcf8EBgDgxa6/cNaT1Qastz4eG64HE4WLsSVaL2zvwSpHRVs+HVRVED7SAmWSvFBk1GDTs42FYHagJXFUQKMXSywTebOVcR3Zb0GDAxKEh4T9EqFcryUzenVryADSvFQgwGgDkHxIeKMS39typJQ8E5T0DMx0ULpoY8EwXotnXqgm8qiq4Uohv7TnlqI8F5UMXvKkzJgY6NnizFEsvqwoCPSZVVUGgkszknXLUJ4jYBTDdb6udMwC+d+4p4llfOFdJZvKkipfRrHX1XBSx0wf+zWBATDndgNMKhLdOOeorJh4XVAVzA7SlI0abdaKdIzVLoOu6YdOCiF2nHA1Ukpk8AAzaFhao/aK1DaYmJ14d/K6XAbh6TN551hcCqjrSgKDssAUcwNexWv21FnR/Kjai82C8MJmkHbQVHAwKlePpbS0W9cWfbz59OTV3/iQIl3rmTbauviKi1VI8fV+fMzympUPHCsCyFcwgxlqx5rhjMP3XePfGYoiZZHSfiZnKDEro2zKQAQD4H94Yqf2qhwgIguBH1y8TORYoOzVh287dfNSwWMQx1l9D3dphXlwT4wAAAABJRU5ErkJggg==';
const iconCrossCircle = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACZklEQVRIidWVQUsbURDHf/PWiHhomqSBYnsqHgqmF+OxhqD0lKpR0I/gJ6gI0oOnqvgN+hFaqMbqSSoh9lSaXrRQUE8ttpAmIR5EKtnpwTXZ7GZNCr04p92Z9/7//8y8Nw9uu8lNQR2a7a3FLrIoWRuGBR4CKPwwShFDLlzu25Svb//8M0E1NTmD6jrwqIPIE1QXIh+3N7oiUJZNdfTLqqALHYBb9wlrkUJySVi23X7jU94EvwTKXWCXgUtRFqup4itvsIWgmpqccYHPqWWngdIN4CVnzVyDZHQi25ZAh2Z7nZoDnKllH0fzO4dq2WMBJCW17DFnzTFw5vjXNTkf8hHUYhdZmg2NSd3sVdKZRABJA7ySziSkbvaAmBMbrPWfTvlLpDrtURiXutmrpKaeRPM7h3WLlMAvoKRixqP5ncPf6YnHpm52gbh7o2IaZTIu53CbMsRF7Q+VdCZxL//+m23Zz9Syx6KF3EElnUlYdQoK972bFB25/u5xuQfaELgzGY/mcwcAV8rZVY/yaxN44MvgP1vjLrgI5DRgccldFne5CDjCCj99BKL6uS24p6EBjW8xgU/+DAy5m5S7GuprvDcTQbd8BOFy3yZw4vyW25xzd0Pjbe7J9Vg5Cp8PNMS2DLvq0+fTiLyjOSqO24D7spS6GQTeAD2IZCOFrUYGvmlaSU2sirLokJzRvKFBVgbuACFBV+7uby+5g75jGikkl1RYA0JdgOOs6RF0Jbw/8tIbDH5wrqbiOjDYgeAIkRfusnRFAKDJ+VCt/3RKMVlRTapcPZkC3xWKgubC5wM5Kb6+7CDiFttfprQtPyCcTqYAAAAASUVORK5CYII=';
const iconWarning =
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABrklEQVRIie2SPUubURiGr/MRCzFKUju0IDg5GLEITkq1L7hoUDf1H7hW3YWubWk76ORv0ClFt1KqjS4Wp5bSqYMWCuH1RRClOXkcNJoU837QbO29nec5z3Wf+5wD/xUhFXejP1IYxJgNQHBuNlfaOmyZgXiePXEdn4GB69KX7NmjQXWw/jtqVscxCFxmqQ4OkA/afz6LMxuZ4JdXeJhy5hvQ+Ufr1FWk78Heu6Ow+cgEbU6/vQMO0GGtehU1H5rAH5sZQ+RD2D6lGM9+LL5v1m+aQDzPIrJWD8/tFFVup9hgJsKqDC2kEhsErnOZxodtpnyQPl5MZFD2JrsFWYkBB0BQz/2RQk9sA1Wxr4FMXAMgLca8iGVwMjo1rhRzCeBXh4L58pOZiTvqt5L+2bbg/vmhQF9Sg2t9z2YqA2p7+6JWaEjgd50v/wUcoDc4tQ0PfpOg7E12a2e/EnL3tS/qj05LiMkZzuVzpa0fUJdAV+2bMHgCpUWbl7WFAig/nRrWVVVqAfxG1SrDXZ+K+xrAiHrcSjiAUVdMDaBTdgPYBcLuNq4E2NX3zGYLWP+CLgFsVnb8c/PU6gAAAABJRU5ErkJggg==';

const insuranceEligibilityToPDF = ({
  inputPDF,
  insuranceEligibility,
  payerName,
}) => new Promise((resolve) => {
  const lineHeight = 1.2;
  const margin = 20;
  const ptsPerMm = 2.834646;
  const fontSize = 10;
  const titleFontSize = 16;
  const subtitleFontSize = 12;
  const captionFontSize = 11;
  const fontType = 'normal';
  const textColor = 0;
  const drawColor = 0;
  const lineHeightMm = fontSize * (lineHeight / ptsPerMm);
  const format = 'a4';
  // eslint-disable-next-line new-cap
  const doc = inputPDF || new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format,
    lineHeight,
  });
  const pageWidth = doc.internal.pageSize.getWidth();
  if (inputPDF) {
    doc.addPage(format, 'p');
  }
  doc.setFont('times');
  let y = margin / 2;
  let x = margin;
  const pageContentWidth = doc.internal.pageSize.getWidth() - (margin * 2);
  let maxWidth = pageContentWidth;
  const setDefaults = () => {
    doc.setFontSize(fontSize);
    doc.setFontType(fontType);
    doc.setTextColor(textColor);
    doc.setDrawColor(drawColor);
  };
  const addY = (newY) => {
    if ((y + newY) < doc.internal.pageSize.getHeight() - margin) {
      y += newY;
    } else {
      doc.addPage();
      y = margin / 2;
    }
  };
  const renderSectionTitle = (title) => {
    x = margin;
    if (y !== margin / 2) {
      addY(margin / 4);
    } else {
      addY(subtitleFontSize * (lineHeight / ptsPerMm));
    }
    doc.setFontType('bold');
    doc.setFontSize(subtitleFontSize);
    doc.setTextColor(palette.secondary.A700);
    doc.text(title, x, y);
    setDefaults();
    addY(subtitleFontSize * (lineHeight / ptsPerMm));
  };
  const renderSectionCaption = (title) => {
    x = margin;
    if (y !== margin / 2) {
      addY(margin / 4);
    } else {
      addY(captionFontSize * (lineHeight / ptsPerMm));
    }
    doc.setFontType('bold');
    doc.setFontSize(captionFontSize);
    doc.setTextColor(palette.secondary.A700);
    doc.text(title, x, y);
    setDefaults();
    addY(captionFontSize * (lineHeight / ptsPerMm));
  };
  const renderSectionLine = (key, value, highlightValue) => {
    doc.setTextColor(palette.grey[800]);
    doc.setFontType('bold');
    const lineTitle = value ? doc.splitTextToSize(`${key}:`, pageContentWidth)
      : doc.splitTextToSize(key, pageContentWidth);
    const titleWidth = doc.getTextWidth(lineTitle[0]);
    lineTitle.forEach((line) => {
      doc.text(line, x, y);   
      if (!value) {
        addY(fontSize * (lineHeight / ptsPerMm));
      }
    });
    setDefaults();
    const lineValue = value ? doc.splitTextToSize(value.toString(), pageContentWidth - titleWidth) : null; 
    if (lineValue) {
      const valueX = x + titleWidth + 3;
      lineValue.forEach((line) => {
        if (highlightValue) {
          doc.setFillColor(palette.active[200]);
          doc.rect(valueX - 0.5, (y - (fontSize * (lineHeight / ptsPerMm))) + 0.5, doc.getTextWidth(line) + 1,
            (fontSize * (lineHeight / ptsPerMm)) + 0.5, 'F');
        }
        doc.text(line, valueX, y);
        addY(fontSize * (lineHeight / ptsPerMm));
      });
    }
  };
  const renderTitle = () => {
    const fullName = insuranceEligibility.subscriber
      && insuranceEligibility.subscriber.firstName
      && insuranceEligibility.subscriber.lastName
      ? `${insuranceEligibility.subscriber.firstName} ${insuranceEligibility.subscriber.lastName}`
      : `${insuranceEligibility.ins_name_f} ${insuranceEligibility.ins_name_l}`;
    const dateOfBirth = insuranceEligibility.subscriber
      && insuranceEligibility.subscriber.dateOfBirth
      ? moment(insuranceEligibility.subscriber.dateOfBirth, apiDateFormat)
        .format(dateFormat)
      : moment(insuranceEligibility.ins_dob, apiDateFormat)
        .format(dateFormat);
    const age = dateOfBirth ? patientDobToAge(dateOfBirth) : null;
    doc.setFontSize(titleFontSize);
    doc.setFontType('bold');
    x = margin;
    maxWidth = pageContentWidth * 0.75;
    if (fullName) {
      addY(titleFontSize * (lineHeight / ptsPerMm));
      doc.setTextColor(palette.secondary.A700);
      doc.text(fullName, x, y);
      if (dateOfBirth) {
        addY(subtitleFontSize * (lineHeight / ptsPerMm));
        doc.setFontSize(subtitleFontSize);
        doc.text(`${dateOfBirth} (${age} ${formatSinglePlural({
          quantity: age, single: 'year', plural: 'years',
        })} old)`, x, y);
      }
    }
    doc.setFontSize(subtitleFontSize);
    doc.setTextColor(textColor);
    doc.setFontType('normal');
    const currentMoment = moment();
    if (insuranceEligibility.plan_number) {
      const subtitle = `${payerName} Medical Eligibility (as of ${currentMoment.format(dateFormat)})`;
      const text = doc.splitTextToSize(subtitle, maxWidth);
      text.forEach((line) => {
        addY(subtitleFontSize * (lineHeight / ptsPerMm));
        doc.text(line, x, y);
      });
    }
    addY(subtitleFontSize * (lineHeight / ptsPerMm));
    if (insuranceEligibility.ins_sex) {
      renderSectionLine('Gender', insuranceEligibility.ins_sex === 'F' ? 'Female' : 'Male');
    }
    if (insuranceEligibility.ins_number) {
      renderSectionLine('Insurance Number', insuranceEligibility.ins_number);
    }
    if (insuranceEligibility.group_name) {
      renderSectionLine('Group Name', insuranceEligibility.group_name);
    }
    if (insuranceEligibility.group_number) {
      renderSectionLine('Group Number', insuranceEligibility.group_number);
    }
    if (insuranceEligibility.plan_number) {
      renderSectionLine('Plan Number', insuranceEligibility.plan_number);
    }
    if (insuranceEligibility.ins_addr_1) {
      renderSectionLine('Address', [
        insuranceEligibility.ins_addr_1,
        insuranceEligibility.ins_city, `${insuranceEligibility.ins_state} ${insuranceEligibility.ins_zip}`,
      ].filter(item => item).join(', '));
    }
    if (insuranceEligibility.plan_begin_date) {
      let planRange = null;
      let activeStatus = false;

      planRange = [
        insuranceEligibility.plan_begin_date.split('-')[0],
        insuranceEligibility.plan_begin_date.split('-')[1],
      ].filter(item => item).map(item => moment(item, apiDateFormat));

      if (planRange) {
        addY(subtitleFontSize * (lineHeight / ptsPerMm));
        setDefaults();

        if (planRange.length === 2) {
          activeStatus = planRange[0].isBefore(currentMoment)
            && planRange[1].isAfter(currentMoment);
        }
        if (planRange.length === 1) {
          activeStatus = planRange[0].isBefore(currentMoment);
        }

        doc.setTextColor(activeStatus ? palette.active[800] : palette.validation[600]);
        doc.addImage(activeStatus ? iconCheckCircle : iconCrossCircle, 'PNG', x, y - (10 / ptsPerMm), 12 / ptsPerMm, 12 / ptsPerMm);
        x += 14 / ptsPerMm;
        doc.text(`Active From: ${planRange.map(item => moment(item, apiDateFormat).format(dateFormat)).join('-')}`, x, y);
        setDefaults();
      }
    } else if (insuranceEligibility.plan_date) {
      let planRange = null;
      let activeStatus = false;

      planRange = [
        insuranceEligibility.plan_date.split('-')[0],
        insuranceEligibility.plan_date.split('-')[1],
      ].filter(item => item).map(item => moment(item, apiDateFormat));

      if (planRange) {
        addY(subtitleFontSize * (lineHeight / ptsPerMm));
        setDefaults();

        if (planRange.length === 2) {
          activeStatus = planRange[0].isBefore(currentMoment)
            && planRange[1].isAfter(currentMoment);
        }
        if (planRange.length === 1) {
          activeStatus = planRange[0].isBefore(currentMoment);
        }

        doc.setTextColor(activeStatus ? palette.active[800] : palette.validation[600]);
        doc.addImage(activeStatus ? iconCheckCircle : iconCrossCircle, 'PNG', x, y - (10 / ptsPerMm), 12 / ptsPerMm, 12 / ptsPerMm);
        x += 14 / ptsPerMm;
        doc.text(`Active From: ${planRange.map(item => moment(item, apiDateFormat).format(dateFormat)).join('-')}`, x, y);
        setDefaults();
      }
    }
    if (insuranceEligibility.eligibility_begin_date) {
      addY(subtitleFontSize * (lineHeight / ptsPerMm));
      x = margin;
      renderSectionLine('Eligibility Begin', moment(insuranceEligibility.eligibility_begin_date, apiDateFormat).format(dateFormat));
    }   
  };

  const renderEligibilityErrors = () => {
    addY(margin / 2);
    doc.setTextColor(palette.validation[600]);
    x = margin;
    doc.addImage(iconWarning, 'PNG', x, y - (10 / ptsPerMm), 12 / ptsPerMm, 12 / ptsPerMm);
    x += 14 / ptsPerMm;
    insuranceEligibility.errors.forEach((item) => {
      let errorLine = item.description ? item.description : null;
      if (item.followupAction) {
        errorLine = errorLine ? `${errorLine}; ${item.followupAction}` : item.followupAction;
      }
      doc.text(errorLine, x, y);
    });
    setDefaults();
  };

  const renderTableTitle = (text) => {
    x = margin;
    if (y !== margin / 2) {
      addY(margin / 4);
    } else {
      addY(subtitleFontSize * (lineHeight / ptsPerMm));
    }
    doc.setFontType('bold');
    doc.setFontSize(subtitleFontSize);
    doc.setTextColor(palette.secondary.A700);
    doc.text(text, x, y);
    setDefaults();
  };

  const renderTableHead = (text, columnIndex = 0) => {
    if (columnIndex === 0) {
      x = margin + ((pageWidth - (2 * margin)) * 0.2);
    } else {
      x = margin + ((pageWidth - (2 * margin)) * 0.6);
    }
    doc.setFontType('bold');
    doc.setFontSize(subtitleFontSize);
    doc.setTextColor(palette.secondary.A700);
    doc.text(text, x, y);
    setDefaults();
  };

  const renderCellTitle = (text, columnIndex = 0) => {
    if (columnIndex === 0) {
      x = margin + ((pageWidth - (2 * margin)) * 0.2);
    } else {
      x = margin + ((pageWidth - (2 * margin)) * 0.6);
    }
    doc.setFontType('bold');
    doc.setFontSize(subtitleFontSize);
    doc.text(text, x, y);
    setDefaults();
  };
  const renderCellSubtitle = (text, columnIndex = 0) => {
    if (columnIndex === 0) {
      x = margin + ((pageWidth - (2 * margin)) * 0.2);
    } else {
      x = margin + ((pageWidth - (2 * margin)) * 0.6);
    }
    doc.setTextColor(palette.grey[800]);
    doc.text(text, x, y);
    setDefaults();
  };

  const renderCellListItem = (text, columnIndex = 0) => {
    if (columnIndex === 0) {
      x = margin + ((pageWidth - (2 * margin)) * 0.2);
    } else {
      x = margin + ((pageWidth - (2 * margin)) * 0.6);
    }
    text.forEach((line, index) => {
      const lineText = index === 0 ? `- ${line}` : line;
      doc.text(lineText, x, y + (index * (fontSize * (lineHeight / ptsPerMm))));
    });
    setDefaults();
  };

  const renderTableSeparator = () => {
    doc.setDrawColor(palette.secondary.A700);
    x = margin + ((pageWidth - (2 * margin)) * 0.2);
    doc.line(x, (y + (margin / 5)), pageWidth - margin, (y + (margin / 5)));
    addY((fontSize * (lineHeight / ptsPerMm)));
  };

  const renderTable = (benefits) => {
    const getCell = (item) => {
      let timeQualifier = item.benefit_period_description;
      let benefitAmount = item.benefit_amount ? formatPrice(item.benefit_amount) : 0;
      if (timeQualifier === 'Contract' || timeQualifier === 'Visit') {
        timeQualifier = `per ${timeQualifier}`;
      }
      const coverageLevel = item.benefit_level_description ? item.benefit_level_description : null;
      const additionalInformation = [item.benefit_notes];
      return {
        title: timeQualifier ? `${benefitAmount} ${timeQualifier}` : null,
        subtitle: coverageLevel,
        list: additionalInformation,
      };
    };
    benefits.forEach((item, index) => {
      const row = {
        inNetwork: getCell(item.inNetwork),
        outOfNetwork: getCell(item.outOfNetwork),
      };
      if (row.inNetwork.title) {
        renderCellTitle(row.inNetwork.title);
      }
      if (row.outOfNetwork.title) {
        renderCellTitle(row.outOfNetwork.title, 1);
      }
      if (row.inNetwork.title || row.outOfNetwork.title) {
        addY((fontSize * (lineHeight / ptsPerMm)));
      }
      if (row.inNetwork.subtitle) {
        renderCellSubtitle(row.inNetwork.subtitle);
      }
      if (row.outOfNetwork.subtitle) {
        renderCellSubtitle(row.outOfNetwork.subtitle, 1);
      }
      if (row.inNetwork.subtitle || row.outOfNetwork.subtitle) {
        addY((fontSize * (lineHeight / ptsPerMm)));
      }
      const inNetworkListLength = row.inNetwork.list ? row.inNetwork.list.length : 0;
      const outOfNetworkListLength = row.outOfNetwork.list ? row.outOfNetwork.list.length : 0;
      const listLength = Math.max(inNetworkListLength, outOfNetworkListLength);
      if (listLength > 0) {
        for (let i = 0; i < listLength; i += 1) {
          let listItemLinesLength = 0;
          if (row.inNetwork.list && row.inNetwork.list[i]) {
            const listItemText = doc.splitTextToSize(row.inNetwork.list[i],
              (pageWidth - (2 * margin)) * 0.38);
            listItemLinesLength = listItemText.length;
            renderCellListItem(listItemText);
          }
          if (row.outOfNetwork.list && row.outOfNetwork.list[i]) {
            const listItemText = doc.splitTextToSize(row.outOfNetwork.list[i],
              (pageWidth - (2 * margin)) * 0.38);
            if (listItemText.length > listItemLinesLength) {
              listItemLinesLength = listItemText.length;
            }
            renderCellListItem(listItemText);
          }
          addY(listItemLinesLength * (fontSize * (lineHeight / ptsPerMm)));
        }
      }
      if (index !== benefits.length - 1) {
        addY((fontSize * (lineHeight / ptsPerMm)));
      }
    });
  };

  const renderEligibilityBenefitsSummary = () => {
    const benefits = insuranceEligibility.benefit
      .reduce((accumulator, currentItem) => {
        if ((['Out of Pocket (Stop Loss)', 'Deductible', 'Co-Insurance', 'Co-Payment']
          .indexOf(currentItem.benefit_coverage_description) !== -1
          && currentItem.benefit_period_description)
          || currentItem.benefit_coverage_description === 'Limitations') {
          let group;
          switch (currentItem.benefit_coverage_description) {
            case 'Out of Pocket (Stop Loss)':
              group = 'outOfPocket';
              break;
            case 'Deductible':
              group = 'deductible';
              break;
            case 'Co-Insurance':
              group = 'coInsurance';
              break;
            case 'Co-Payment':
              group = 'coPayment';
              break;
            case 'Limitations':
              group = 'limitations';
              break;
            default:
              group = 'outOfPocket';
          }
          if (currentItem.inplan_network === 'Y') {
            let newItemIndex = accumulator[group].findIndex(item => (currentItem.benefit_coverage_description === 'Limitations'
              ? (item.benefit_description
                === currentItem.benefit_description)
              : (item.outOfNetwork.benefit_period_description === currentItem.benefit_period_description
                && item.outOfNetwork.benefit_level_description === currentItem.benefit_level_description)));
            if (newItemIndex === -1) {
              newItemIndex = accumulator[group].length;
              return {
                ...accumulator,
                [group]: [
                  ...accumulator[group].slice(0, newItemIndex),
                  {
                    outOfNetwork: {
                      ...currentItem,
                      benefit_amount: '0',
                      additionalInformation: null,
                    },
                    inNetwork: currentItem,
                  },
                  ...accumulator[group].slice(newItemIndex + 1),
                ],
              };
            }
            return {
              ...accumulator,
              [group]: [
                ...accumulator[group].slice(0, newItemIndex),
                {
                  outOfNetwork: accumulator[group][newItemIndex].outOfNetwork,
                  inNetwork: currentItem,
                },
                ...accumulator[group].slice(newItemIndex + 1),
              ],
            };
          }
          let newItemIndex = accumulator[group].findIndex(item => (currentItem.benefit_coverage_description === 'Limitations'
            ? (item.benefit_description
                === currentItem.benefit_description)
              : (item.outOfNetwork.benefit_period_description === currentItem.benefit_period_description
                && item.outOfNetwork.benefit_level_description === currentItem.benefit_level_description)));
          if (newItemIndex === -1) {
            newItemIndex = accumulator[group].length;
            return {
              ...accumulator,
              [group]: [
                ...accumulator[group].slice(0, newItemIndex),
                {
                  inNetwork: {
                    ...currentItem,
                    benefit_amount: '0',
                    additionalInformation: null,
                  },
                  outOfNetwork: currentItem,
                },
                ...accumulator[group].slice(newItemIndex + 1),
              ],
            };
          }
          if (accumulator[group][newItemIndex]
            && accumulator[group][newItemIndex].outOfNetwork
            && accumulator[group][newItemIndex].outOfNetwork.benefit_amount
            && Number(accumulator[group][newItemIndex].outOfNetwork.benefit_amount) !== 0
            && currentItem.benefit_amount && Number(currentItem.benefit_amount)
              < Number(accumulator[group][newItemIndex].outOfNetwork.benefit_amount)) {
            return accumulator;
          }
          return {
            ...accumulator,
            [group]: [
              ...accumulator[group].slice(0, newItemIndex),
              {
                inNetwork: accumulator[group][newItemIndex].inNetwork,
                outOfNetwork: currentItem,
              },
              ...accumulator[group].slice(newItemIndex + 1),
            ],
          };
        }
        return accumulator;
      }, {
        outOfPocket: [],
        deductible: [],
        coPayment: [],
        coInsurance: [],
        limitations: [],
      });
    if (benefits.deductible.length > 0
      || benefits.outOfPocket.length > 0
      || benefits.coInsurance.length > 0
      || benefits.coPayment.length > 0) {
      addY(margin / 4);
      renderTableHead('In-Network:');
      renderTableHead('Out-of-Network:', 1);
    }
    if (benefits.deductible.length > 0) {
      renderTableSeparator();
      renderTableTitle('Deductible');
      renderTable(benefits.deductible);
    }
    if (benefits.outOfPocket.length > 0) {
      renderTableSeparator();
      renderTableTitle('Out Of Pocket');
      renderTable(benefits.outOfPocket);
    }
    if (benefits.coInsurance.length > 0) {
      renderTableSeparator();
      renderTableTitle('Co-Insurance');
      renderTable(benefits.coInsurance);
    }
    if (benefits.coPayment.length > 0) {
      renderTableSeparator();
      renderTableTitle('Co-Payment');
      renderTable(benefits.coPayment);
    }
    if (benefits.limitations.length > 0) {
      renderTableSeparator();
      renderTableTitle('Limitations');
      renderTable(benefits.limitations);
    }
  };

  const renderEligibilityBenefitsInformation = () => {
    const isPriorityBenefit = (item) =>
      item.benefit_coverage_description === 'Primary Care Provider'
      || item.benefit_coverage_description === 'Health Care Facility';
    // const sortedBenefits = [...insuranceEligibility.benefit].sort((a, b) => {
    //   const aFirst = isPriorityBenefit(a) ? 0 : 1;
    //   const bFirst = isPriorityBenefit(b) ? 0 : 1;
    //   return aFirst - bFirst;
    // });
    const groupedByCode = groupBy(insuranceEligibility.benefit, 'benefit_code');
    Object.keys(groupedByCode)
      .sort((a, b) => {
        if (a === 'undefined') return -1;
        if (b === 'undefined') return 1;
        return 0;
      })
      .forEach(codeKey => {
        const group = groupedByCode[codeKey];
        if (codeKey === 'undefined') {
          const withPrimaryCareProvider = group.find(item => isPriorityBenefit(item));
          if (withPrimaryCareProvider) {
            renderSectionTitle('Primary Care Provider');
          }
        } else {
          renderSectionTitle(`${group[0].benefit_description} (${codeKey})`);
        }
        const groupedByLevel = groupBy(group, 'benefit_level_description');
        Object.keys(groupedByLevel).forEach(levelKey => {
          const levelGroup = groupedByLevel[levelKey];
          const groupedByInPlan = groupBy(levelGroup, 'inplan_network');
          Object.keys(groupedByInPlan).forEach(inPlanKey => {
            let inPlanGroup = groupedByInPlan[inPlanKey];
            let inPlanLevelTitle = levelKey;
            if (inPlanKey === 'Y') {
              inPlanLevelTitle = `${levelKey} In-Plan-Network`;
            }
            if (inPlanKey === 'N') {
              inPlanLevelTitle = `${levelKey} Out-Of-Plan-Network`;
            }
            if (inPlanLevelTitle && inPlanLevelTitle !== 'undefined') {
              renderSectionCaption(inPlanLevelTitle);
              addY(margin / 4);
            }
            if (codeKey === 'undefined') {
              inPlanGroup = inPlanGroup.sort((a, b) => {
                const aFirst = isPriorityBenefit(a) ? 0 : 1;
                const bFirst = isPriorityBenefit(b) ? 0 : 1;
                return aFirst - bFirst;
              });
            }
            inPlanGroup.forEach((item) => {
              if (item.benefit_coverage_description) {
                if (['Limitations', 'Unlimited'].indexOf(item.benefit_coverage_description) !== -1) {
                  renderSectionLine(item.benefit_coverage_description, item.benefit_notes ? item.benefit_notes : item.benefit_period_description);
                } else {
                  let lineValue;
                  if (item.benefit_amount) {
                    lineValue = item.benefit_period_description ? `${formatPrice(item.benefit_amount)} ${item.benefit_period_description}`
                    : formatPrice(item.benefit_amount);
                  }
                  if (item.benefit_percent) {
                    lineValue = item.benefit_period_description ? `${item.benefit_percent} ${item.benefit_period_description}`
                    : item.benefit_percent;
                  }
                  if (item.insurance_plan) {
                    renderSectionLine('Insurance Plan', item.insurance_plan);
                  }
                  if (item.entity_description) {
                    item.entity_description.forEach((entity, index) => {
                      renderSectionLine(entity, item.entity_name && item.entity_name[index] ? item.entity_name[index] : null);
                    });
                  }
                  if (item.period_start) {
                    renderSectionLine('Period Start Date', moment(item.period_start, apiDateFormat).format(dateFormat));
                  }
                  if (item.period_end) {
                    renderSectionLine('Period End Date', moment(item.period_end, apiDateFormat).format(dateFormat));
                  }
                  if (item.eligibility_begin) {
                    renderSectionLine('Eligibility Begin Date', moment(item.eligibility_begin, apiDateFormat).format(dateFormat));
                  }
                  if (item.eligibility_end) {
                    renderSectionLine('Eligibility End Date', moment(item.eligibility_end, apiDateFormat).format(dateFormat));
                  }
                  if (item.benefit_begin) {
                    renderSectionLine('Benefit Begin Date', moment(item.benefit_begin, apiDateFormat).format(dateFormat));
                  }
                  if (item.benefit_end) {
                    renderSectionLine('Benefit End Date', moment(item.benefit_end, apiDateFormat).format(dateFormat));
                  }
                  if (item.entity_addr_1) {
                    let address = [
                      item.entity_addr_1[0],
                      ...item.entity_city ? [item.entity_city[0]] : [],
                      ...item.entity_state ? [item.entity_state[0]] : [],
                    ].filter(addressItem => addressItem).join(', ');
                    if (item.entity_zip) {
                      address = `${address} ${item.entity_zip[0]}`;
                    }
                    renderSectionLine('Payer Address', address);
                  }
                  if (item.entity_phone) {
                    renderSectionLine('Phone Number', item.entity_phone.join(', '));
                  }
                  if (item.benefit_notes) {
                    renderSectionLine(item.benefit_notes);
                  }
                  renderSectionLine(item.insurance_type_description
                    ? `${item.insurance_type_description} ${item.benefit_coverage_description}` : item.benefit_coverage_description, lineValue);
                }
                addY(fontSize * (lineHeight / ptsPerMm));
              }
            });
          });
        });
        doc.setDrawColor(palette.secondary.A700);
        doc.setLineWidth(0.5);
        doc.line(margin, y, pageWidth - margin, y);
        addY(margin / 6);
      });
  };

  renderTitle();
  if (insuranceEligibility.benefit) {
    renderEligibilityBenefitsInformation();
  }
  resolve(doc);
});

export default insuranceEligibilityToPDF;



// WEBPACK FOOTER //
// ./src/utils/insuranceEligibilityToPDF.js